/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placelunchflyereveryweek4Inputs */

const en_placelunchflyereveryweek4 = /** @type {(inputs: Placelunchflyereveryweek4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every week`)
};

const de_placelunchflyereveryweek4 = /** @type {(inputs: Placelunchflyereveryweek4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Woche`)
};

/**
* | output |
* | --- |
* | "Every week" |
*
* @param {Placelunchflyereveryweek4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placelunchflyereveryweek4 = /** @type {((inputs?: Placelunchflyereveryweek4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placelunchflyereveryweek4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placelunchflyereveryweek4(inputs)
	return de_placelunchflyereveryweek4(inputs)
});
export { placelunchflyereveryweek4 as "placeLunchFlyerEveryWeek" }